import { Container } from 'unstated';

class BasketContainer extends Container {
  state = {
    basket: {},
    value: 0,
    qty: 0,
    details: {}
  };

  resetBasket = () => {
    this.setState({
      basket: {},
      value: 0,
      qty: 0,
      details: {}
    });
  };
  getOptionalItemTotal = options => {
    return Object.keys(options).reduce((acc, key, idx) => {
      return options[key].qty * options[key].price + acc;
    }, 0);
  };
  updateMenuItem = menuItem => {
    const {
      qty,
      name,
      variation,
      price,
      requiredOptionId,
      requiredItemPrice,
      optionalOptions,
      removedOptions,
      requiredOptionName
    } = menuItem;
    const totalWithoutOptions = (requiredItemPrice + price) * qty;
    const optionsTotal = this.getOptionalItemTotal(optionalOptions);
    const totalOptions = optionsTotal * qty;
    const basket = {
      qty,
      name,
      variation,
      unitPrice: price,
      totalPrice: price * qty,
      totalPriceWithOptions: totalWithoutOptions + totalOptions,
      requiredOptions: {
        [requiredOptionId]: {
          qty,
          unitPrice: requiredItemPrice,
          totalPrice: qty * requiredItemPrice,
          name: requiredOptionName
        }
      },
      optionalOptions: { ...optionalOptions },
      removedOptions: { ...removedOptions }
    };
    return basket;
  };
  update = (item, key, action, name) => {
    const oldBasket = this.state.basket;
    const details = {};
    let totalQty = 0;

    if (action === 'removed') {
      if (oldBasket[key]) {
        delete oldBasket[key];
        item = {};
      }
    }

    const newBasket = { ...oldBasket, ...item };
    const total = Object.keys(newBasket).reduce((acc, key, idx) => {
      const basketItem = newBasket[key];
      totalQty = totalQty + basketItem.qty;
      details[key] = this.updateMenuItem(basketItem);
      return details[key].totalPriceWithOptions + acc;
    }, 0);

    // if (this.state.value !== total || this.state.qty !== totalQty) {
    //on;y change if the basket has been updated
    this.setState(
      state => {
        return {
          value: total,
          basket: newBasket,
          details,
          qty: totalQty
        };
      },
      () => {}
    );
  };
  // };
}

export default BasketContainer;



// WEBPACK FOOTER //
// ./src/containers/BasketContainer.js